import React, { useState } from 'react';
import { styled } from '@mui/material/styles';
import { grey } from '@mui/material/colors';
import {
  SwipeableDrawer,
  Typography,
  Box,
  useMediaQuery,
  useTheme,
  GlobalStyles,
} from '@mui/material';
import LocationSharingPanel from './LocationSharingPanel';
import { t } from 'i18next';
import { StringKeys } from '@/resources/strings/StringKeys';

// Styled components for the bottom drawer
const drawerBleeding = 56;

const Puller = styled('div')(({ theme }) => ({
  width: 40,
  height: 6,
  backgroundColor: grey[300],
  borderRadius: 3,
  position: 'absolute',
  top: 8,
  left: 'calc(50% - 15px)',
  ...(theme.palette.mode === 'dark'
    ? {
        backgroundColor: grey[900],
      }
    : {}),
}));

function LocationSharingDrawer() {
  const [open, setOpen] = useState(false);
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));
  return (
    isSmallScreen && (
      <>
        <GlobalStyles
          styles={{
            '.MuiDrawer-root > .MuiPaper-root': {
              height: `calc(100% - ${drawerBleeding}px)`,
              overflow: 'visible',
            },
          }}
        />
        <SwipeableDrawer
          anchor="bottom"
          open={open}
          onClose={() => setOpen(false)}
          onOpen={() => setOpen(true)}
          swipeAreaWidth={isSmallScreen ? drawerBleeding : 0}
          disableSwipeToOpen={!isSmallScreen} // Only enable swipe on small screens
          keepMounted
          ModalProps={{
            BackdropProps: {
              sx: {
                backgroundColor: 'rgba(0, 0, 0, 0)', // transparent backdrop (scrim)
              },
              onTouchStart: (e) => {
                // Close the drawer when touching outside of it
                setOpen(false);
              },
            },
          }}
          sx={{
            display: { xs: 'block', sm: 'none' }, // Only show on xs screens, hide on sm screens and above
            '& .MuiDrawer-paper': {
              borderTopLeftRadius: 24,
              borderTopRightRadius: 24,
            },
            // Only show the swipe area on small screens
            '& .MuiPrivateSwipeArea-root': {
              display: isSmallScreen ? 'block' : 'none',
            },
          }}
        >
          <Box
            sx={{
              position: 'absolute',
              top: -drawerBleeding,
              borderTopLeftRadius: 16,
              borderTopRightRadius: 16,
              visibility: 'visible',
              borderTop: '1px solid #eee',
              boxShadow: '0px -4px 16px rgba(0,0,0,0.08)',
              right: 0,
              left: 0,
              backgroundColor: 'background.paper',
              cursor: 'pointer',
            }}
          >
            <Puller />
            <Typography
              sx={{
                p: 2,
                color: 'text.secondary',
                textAlign: 'center',
              }}
            >
              {t(StringKeys.GROUPS_AND_WORKERS)}
            </Typography>
          </Box>
          <Box sx={{ height: '100%', overflow: 'auto' }}>
            <LocationSharingPanel />
          </Box>
        </SwipeableDrawer>
      </>
    )
  );
}

export default LocationSharingDrawer;
